export default {
      id: "i-noun-protect-usage",
      viewBox: "0 0 33 43",
      url: __webpack_public_path__ + "img/sprite.svg#i-noun-protect",
      toString: function () {
        return this.url;
      }
    }